import PropTypes from 'prop-types'
import React from 'react'
import { components } from 'react-select'

const Control = props => (
  <components.Control
    {...props}
    className={props.selectProps.controlClassName}
  />
)

Control.propTypes = {
  selectProps: PropTypes.object,
}

export default Control
